import React, { Component } from "react";
import axios from "axios";
import Swal from 'sweetalert2'
import { getErrorsMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
class UserForm extends Component {
    static contextType = LangContext;

    constructor(props) {
        super(props);
        this.state = {
            roles: [],
            formData: { name: '', email: '', role_id: '', active: true, notifications: true, document_notifications: true },
            disabled: false,
            editMode: window.location.pathname.endsWith('edit'),
            profiles: [],
            costCenters: [],
            totalCostCenters: [],
            totalProfiles: [],
            selectedProfiles: [],
            selectedProfilesIds: [],
            selectedCenterCost: [],
            selectedCenterCostIds: [],
        };
    }

    getRoles = async () => {
        const rolesList = await axios.get('/api/roles')
        this.setState({ roles: rolesList.data })
    }

    handleChangeInput = (ev) => {
        const { formData } = this.state;
        if (ev.target.type == 'checkbox') {
            const checkboxVal = ev.target.value === 'true' ? true : false
            if (ev.target.name == 'active') {
                if (checkboxVal == true) {
                    const updatedValues = { "active": false, "notifications": false, "document_notifications": false };
                    this.setState({ formData: { ...formData, ...updatedValues } });
                } else {
                    this.setState({ formData: { ...formData, ['active']: true } });
                }
            } else {
                this.setState({ formData: { ...formData, [ev.target.name]: !checkboxVal } });
            }
        } else {
            this.setState({ formData: { ...formData, [ev.target.name]: ev.target.value } });
        }
    }

    displayList = async (ev) => {
        var url = '/api/profiles';
        const query = new URLSearchParams();
        query.append('search', ev.target.value)
        const qs = query.toString();
        const res = await axios.get(url+`?${qs}`);
        this.setState({ profiles: res.data.data })
        setTimeout(function(){
            // clear suggestions after a while
        }, 10000);
    }

    handleSearchProfile = async (ev) => {
        var url = '/api/profiles';
        const query = new URLSearchParams();
        query.append('search', ev.target.value)
        const qs = query.toString();
        const res = await axios.get(url+`?${qs}`);
        this.setState({ profiles: res.data.data })
    }

    displayListCostCenter = async (ev) => {
        var url = '/api/cost_centers';
        const query = new URLSearchParams();
        query.append('search', ev.target.value)
        const qs = query.toString();
        const res = await axios.get(url+`?${qs}`);
        this.setState({ costCenters: res.data.data })
        setTimeout(function(){
            // clear suggestions after a while
        }, 10000);;
    }

    costCentersCount = async (ev) => {
        var url = '/api/cost_centers';
        const query = new URLSearchParams();
        const qs = query.toString();
        const res = await axios.get(url );
        this.setState({ totalCostCenters: res.data.data.length })
    }
    profilesCount = async (ev) => {
        var url = '/api/profiles';
        const query = new URLSearchParams();
        const qs = query.toString();
        const res = await axios.get(url );
        this.setState({ totalProfiles: res.data.data.length })
    }

    handleSearchCostCenter = async (ev) => {
        var url = '/api/cost_centers';
        const query = new URLSearchParams();
        query.append('search', ev.target.value)
        const qs = query.toString();
        const res = await axios.get(url+`?${qs}`);
        this.setState({ costCenters: res.data.data })
    }

    addCenterCost = async (p) => {
        const { selectedCenterCost, selectedCenterCostIds } = this.state;
        this.setState({ costCenters: [] })
        let selected  = selectedCenterCost.filter(function(p) {
            return p.id != 1
        })
        let selectedIds  = selectedCenterCostIds.filter(function(p) {
            return p != 1
        })
        this.setState({ selectedCenterCost: selected, selectedCenterCostIds: selectedIds })
        let exist = selectedCenterCost.filter((u)=>{
            if(u.id == p.id){
                return u
            }
        })
        if(exist.length == 0){
            selected.push(p)
            selectedIds.push(p.id)
            this.setState({ selectedCenterCost: selected, selectedCenterCostIds: selectedIds })
        }
    }

    addProfile = async (p) => {
        const { selectedProfiles, selectedProfilesIds } = this.state;
        this.setState({ profiles: [] })
        let selected  = selectedProfiles.filter(function(p) {
            return p.id != 1
        })
        let selectedIds  = selectedProfilesIds.filter(function(p) {
            return p != 1
        })
        this.setState({ selectedProfiles: selected, selectedProfilesIds: selectedIds })

        let exist = selectedProfiles.filter((u)=>{
            if(u.id == p.id){
                return u
            }
        })
        if(exist.length == 0){
            selected.push(p)
            selectedIds.push(p.id)
            this.setState({ selectedProfiles: selected, selectedProfilesIds: selectedIds })
        }
    }

    getUserProfiles = async ()=>{
        const userId = window.location.pathname.split('/')[2]
        const userInfo = await axios.post(`/api/users/profiles`,{
            userId:userId
        }).then(res=>{
            this.setState({ selectedProfiles: res.data })
            let ids = res.data.map(a => a.id);
            this.setState({ selectedProfilesIds: ids })
        })
    }

    getUserCostCenters = async ()=>{
        const userId = window.location.pathname.split('/')[2]
        const userInfo = await axios.post(`/api/users/cost_centers`,{
            userId:userId
        }).then(res=>{
            this.setState({ selectedCenterCost: res.data })
            let ids = res.data.map(a => a.id);
            this.setState({ selectedCenterCostIds: ids })
        })
    }

    getUser = async () => {
        if(this.state.editMode){
        const userId = window.location.pathname.split('/')[2]
        const userInfo = await axios.get(`/api/users/show/${userId}`)
        if(userInfo.status == 200){
            const { name, email, role_id, active, notifications,document_notifications } = userInfo.data
                this.setState({ disabled: true, formData: { name, email, role_id, userId, active, notifications, document_notifications } })
            }
        }
    }
    deleteCostCenter = async(costCenter)=>{
        const { selectedCenterCost, selectedCenterCostIds } = this.state;
        let selectedCenterCosts  = selectedCenterCost.filter(function(p) {
            return costCenter.id !== p.id
        })
        let selectedCenterCostIdsDeleted  = selectedCenterCostIds.filter(function(p) {
            return costCenter.id !== p
        })
        this.setState({ selectedCenterCost: selectedCenterCosts, selectedCenterCostIds: selectedCenterCostIdsDeleted })
        if(selectedCenterCosts.length == 0){
            this.setState({ selectedCenterCost: [{
                id:1,
                name:'Todos'
            }], selectedCenterCostIds: [1] })
        }
    }

    deleteProfile = async(profile)=>{
        const { selectedProfiles, selectedProfilesIds } = this.state;
        let selectedProfile  = selectedProfiles.filter(function(p) {
            return profile.id !== p.id
        })
        let selectedProfileIds  = selectedProfilesIds.filter(function(p) {
            return profile.id !== p
        })
        this.setState({ selectedProfiles: selectedProfile, selectedProfilesIds: selectedProfileIds })
        if(selectedProfiles.length == 1){
            this.setState({ selectedProfiles: [{
                id:1,
                name:'Super Admin'
            }], selectedProfilesIds: [1] })
        }
    }

    handleSubmit = async (ev) => {
        ev.preventDefault()
        const { formData, selectedProfilesIds, selectedCenterCostIds, editMode } = this.state;
        const { lang } = this.context;
        if(editMode){
            const { role_id, active, userId, notifications , document_notifications,name} = formData; 
            const URL = `/api/users/edit/${userId}`
            const req = await axios.post(URL, { role_id, active, notifications, document_notifications,selectedProfilesIds, selectedCenterCostIds, name }).catch(function (error) {
                window.unblockUI();
                Swal.fire({
                    text: getErrorsMessage(error),
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: lang.get('messages.aceptar'),
                    customClass: {
                        confirmButton: "btn font-weight-bold btn-primary"
                    }
                });
            })
            const message = req.status == 200 ? lang.get('messages.usuario_actualizado') : 'Error'
            const icon = req.status == 200 ? 'success' : 'warning'
            Swal.fire({
                text: message,
                icon,
                buttonsStyling: false,
                confirmButtonText: lang.get('messages.aceptar'),
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
            }).then((result) => {
                window.location.href = '/users';
            })
        } else {
            window.blockUI();
            const URL = '/api/users/invite'
            const { role_id, active, email, notifications ,document_notifications, name} = formData
            await axios.post(URL, { email, role_id, active, notifications, document_notifications, selectedProfilesIds, selectedCenterCostIds, name }).then(function(response) {
                window.unblockUI();
                Swal.fire({
                    text: response.data['msg'],
                    icon: 'success',
                    buttonsStyling: false,
                    confirmButtonText: lang.get('messages.aceptar'),
                    customClass: {
                        confirmButton: "btn font-weight-bold btn-primary"
                    },
                }).then((result) => {
                    window.location.href = '/users';
                })
            }).catch(function (error) {
                window.unblockUI();
                Swal.fire({
                    text: getErrorsMessage(error),
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: lang.get('messages.aceptar'),
                    customClass: {
                        confirmButton: "btn font-weight-bold btn-primary"
                    }
                });
            });
        }
    }
    componentDidMount() {
        this.costCentersCount()
        this.profilesCount()
        this.getRoles()
        this.getUser()
        this.getUserProfiles()
        this.getUserCostCenters()
        this.closeDropdown = () => {
            this.setState({ profiles: [], costCenters: [] })
        }
        document.body.addEventListener('click', this.closeDropdown)
    }

    componentWillUnmount() {
        if (this.closeDropdown) {
            document.body.removeEventListener('click', this.closeDropdown)
        }
    }

    render() {
    const { lang } = this.context;
    const { roles, formData, disabled, profiles, costCenters, totalCostCenters, totalProfiles, selectedProfiles, selectedProfilesIds, selectedCenterCost, selectedCenterCostIds } = this.state;
    const props = this.props;
    return (
    <div className="d-flex flex-column-fluid">
        <div className="container">
            <form onSubmit={this.handleSubmit}>
            <div className="card card-custom gutter-b   example-compact">
                <div className="card-body">
                    <div className="row">
                        <div className="col-6">
                            <h5 className="text-dark font-weight-bold mb-10">{lang.get('messages.datos_del_usuario')}</h5>
                        </div>
                        <div className="col-2 d-flex align-items-center justify-content-end">
                            <label className="mb-0 mr-4">{lang.get('messages.activo')}</label>
                            <div className="radio-inline">
                                <span className="switch switch-icon">
                                    <label>
                                    <input
                                        onChange={this.handleChangeInput}
                                        type="checkbox"
                                        name="active"
                                        value={Boolean(formData.active)}
                                        checked={Boolean(formData.active)} />
                                    <span></span>
                                    </label>
                                </span>
                            </div>
                        </div>
                        {  ( props.permissions.user_notifications.includes('all') || props.permissions.dossiers_actions.includes('user_notifications') )&&
                        <div className="col-2 d-flex align-items-center justify-content-end">
                            <label className="mb-0 mr-4">{lang.get('messages.notificaciones')}</label>
                            <div className="radio-inline">
                            <span className="switch switch-icon">
                                <label>
                                <input
                                    onChange={this.handleChangeInput}
                                    type="checkbox"
                                    name="notifications"
                                    value={Boolean(formData.notifications)}
                                    checked={Boolean(formData.notifications)} />
                                <span></span>
                                </label>
                            </span>
                            </div>
                        </div>
                        }
                        <div className="col-2 d-flex align-items-center justify-content-end">
                            <label className="mb-0 mr-4">{lang.get('messages.notificaciones_por_documento')}</label>
                            <div className="radio-inline">
                            <span className="switch switch-icon">
                                <label>
                                <input
                                    onChange={this.handleChangeInput}
                                    type="checkbox"
                                    name="document_notifications"
                                    value={Boolean(formData.document_notifications)}
                                    checked={Boolean(formData.document_notifications)} />
                                <span></span>
                                </label>
                            </span>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6 form-group">
                            <label htmlFor="name">{lang.get('messages.nombre')}</label>
                            <input
                            onChange={this.handleChangeInput}
                            id="name"
                            type="text"
                            className="form-control form-control-solid"
                            name="name"
                            value={formData.name}
                            required
                            autoFocus />
                        </div>
                        <div className="col-6 form-group">
                            <label htmlFor="email">Email</label>
                            <input
                                onChange={this.handleChangeInput}
                                id="email"
                                type="text"
                                className="form-control form-control-solid"
                                name="email"
                                value={formData.email}
                                disabled={disabled}
                                required />
                        </div>
                    </div>
                </div>
            </div>
            <div>
            <div className="card card-custom my-5">
                <div className="card-body">
                    <h5 className="text-dark font-weight-bold mb-5">{lang.get('messages.perfiles')}</h5>
                    <div className="row mb-5">
                        <div className="col-7">
                            <div className="input-icon">
                                <input name="search" autoComplete="new-text" onChange={this.handleSearchProfile} onClick={this.displayList}  type="text"  className="form-control form-control-solid form-control-sm" placeholder={lang.get('messages.buscar_perfil')} />
                                <span>
                                    <i className="flaticon2-search-1 text-primary icon-md"></i>
                                </span>
                            </div>
                            <div className="suggestions">
                                {profiles.map((u) => {
                                    return(
                                        <div key={u.id} className="suggestion" onClick={()=>{this.addProfile(u)}}>
                                            {u.name}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div className="col-5">
                        </div>
                    </div>
                    {totalProfiles > 0 &&
                    <table className="table m-0 table-valign">
                        <thead>
                            <tr>
                                <th>{lang.get('messages.perfiles')}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                        { selectedProfiles.map((u) => {
                            return <tr  key={u.id}>
                                <td className="p-5">
                                    <img src="/assets/img/icons/shield.svg" />
                                    <span className="ml-2">{u.name}</span>
                                </td>
                                <td className="text-right">
                                    { u.id != 1 &&
                                    <>
                                        <img className="ml-2" onClick={()=>{this.deleteProfile(u)}} src="/assets/img/icons/trash.svg" alt="" />
                                        <a href={'/profiles/'+u.id+'/edit'}>
                                            <img className="ml-2" src="/assets/img/icons/go-right.svg" alt="" />
                                        </a>
                                    </>
                                    }
                                </td>
                            </tr>
                            })}
                        </tbody>
                    </table>
                    }
                    {totalProfiles == 0 &&
                        <p>{lang.get('messages.no_cuentas_con_perfiles_dados_de_alta')}</p>
                    }
                </div>
            </div>
            <div className="card card-custom my-5">
                <div className="card-body">
                    <h5 className="text-dark font-weight-bold mb-5">{lang.get('messages.centros_de_costos')}</h5>
                    <div className="row mb-5">
                        <div className="col-7">
                            <div className="input-icon">
                                <input name="search" type="text" autoComplete="new-text" onChange={this.handleSearchCostCenter} onClick={this.displayListCostCenter}  className="form-control form-control-solid form-control-sm" placeholder={lang.get('messages.buscar_centros_de_costos')} />
                                <span>
                                    <i className="flaticon2-search-1 text-primary icon-md"></i>
                                </span>
                            </div>
                            <div className="suggestions">
                                {costCenters.map((u) => {
                                    return(
                                        <div key={u.id} className="suggestion" onClick={()=>{this.addCenterCost(u)}}>
                                            {u.name}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div className="col-5">
                        </div>
                    </div>
                    {totalCostCenters > 0 &&
                    <table className="table m-0 table-valign">
                        <thead>
                            <tr>
                                <th>{lang.get('messages.centros_de_costos')}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                        { selectedCenterCost.map((u) => {
                            return <tr key={u.id}>
                                <td className="p-5">
                                    <img src="/assets/img/icons/shield.svg" />
                                    <span className="ml-2">{u.name}</span>
                                </td>
                                <td className="text-right">
                                    { u.id != 1 &&
                                    <>
                                        <img className="ml-2"  onClick={()=>{this.deleteCostCenter(u)}} src="/assets/img/icons/trash.svg" alt="" />
                                        <a href={'/cost_centers/'+u.id+'/edit'}>
                                            <img className="ml-2" src="/assets/img/icons/go-right.svg" alt="" />
                                        </a>
                                    </>
                                    }
                                </td>
                            </tr>
                        })}
                        </tbody>
                    </table>
                    }
                    {totalCostCenters == 0 &&
                        <p>{lang.get('messages.no_cuentas_con_centros_de_costos_dados_de_alta')}</p>
                    }
                </div>
            </div>
            </div>
            <div className="row justify-content-end mt-6">
                <div className="col-3 text-right">
                <a
                    href="/users"
                    className="btn btn-lg btn-secondary">
                {lang.get('messages.cancelar')}
                </a>
                <button
                    type="submit"
                    className="btn btn-lg btn-primary ml-4 text-white">
                    {lang.get('messages.guardar')}
                </button>
                </div>
            </div>
            </form>
        </div>
    </div>
  )
    }
}

export default UserForm
